import { WhitelabelSettingReadModel } from "../../../@api";

import { appSettingsKeys } from "../app-setting-keys";
import { applyCSSSetting } from "./apply-css-setting.function";
import { findWhitelabelSetting as findWLSetting } from "./find-whitelabel-setting.function";
import { getWhitelabelValue } from "./get-whitelabel-value.function";

export const applyWhitelabelSettings = async (settings: WhitelabelSettingReadModel[]) => {
  // Apply CSS settings
  applyCSSSettings(settings);
};

const applyCSSSettings = (settings: WhitelabelSettingReadModel[]) => {
  const appKeys = appSettingsKeys;

  // PrimeNG overrides
  applyCSSSetting("", "text-color", getWhitelabelValue(findWLSetting(settings, appKeys["Color.TextColor"])));
  applyCSSSetting("", "brand-color", getWhitelabelValue(findWLSetting(settings, appKeys["Color.BrandColor"])));
  applyCSSSetting(
    "",
    "brand-color-invalid",
    getWhitelabelValue(findWLSetting(settings, appKeys["Color.BrandColorInvalid"])),
  );

  // Colors
  applyCSSSetting("customer-", "text-color", getWhitelabelValue(findWLSetting(settings, appKeys["Color.TextColor"])));
  applyCSSSetting("customer-", "link-color", getWhitelabelValue(findWLSetting(settings, appKeys["Color.LinkColor"])));
  applyCSSSetting("customer-", "brand-color", getWhitelabelValue(findWLSetting(settings, appKeys["Color.BrandColor"])));
  applyCSSSetting(
    "customer-",
    "brand-color-invalid",
    getWhitelabelValue(findWLSetting(settings, appKeys["Color.BrandColorInvalid"])),
  );
  applyCSSSetting(
    "customer-",
    "brand-color-background",
    getWhitelabelValue(findWLSetting(settings, appKeys["Color.BrandColorBackground"])),
  );
  applyCSSSetting(
    "customer-",
    "brand-color-foreground",
    getWhitelabelValue(findWLSetting(settings, appKeys["Color.BrandColorForeground"])),
  );
  applyCSSSetting(
    "customer-",
    "button-color-background",
    getWhitelabelValue(findWLSetting(settings, appKeys["Color.ButtonColorBackground"])),
  );

  // Borders
  applyCSSSetting(
    "customer-",
    "border-radius",
    getWhitelabelValue(findWLSetting(settings, appKeys["Layout.Border.HasRoundedBorder"]))?.toString() === "true"
      ? undefined
      : 0,
  );
  applyCSSSetting(
    "customer-",
    "border-radius-small",
    getWhitelabelValue(findWLSetting(settings, appKeys["Layout.Border.HasRoundedBorder"]))?.toString() === "true"
      ? undefined
      : 0,
  );

  // Font Family
  applyCSSSetting("", "font-family", getWhitelabelValue(findWLSetting(settings, appKeys["Font.Family"])));
  applyCSSSetting("customer-", "font-family", getWhitelabelValue(findWLSetting(settings, appKeys["Font.Family"])));

  // Other settings
  applyCSSSetting(
    "customer-",
    "header-row-direction",
    getWhitelabelValue(findWLSetting(settings, appKeys["Layout.Positions.IsLogoLeft"]))?.toString() === "true"
      ? "row"
      : "row-reverse",
  );
};
